// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2lNJE","title":"FrontImage_title__2T0RD"};